import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { AuthShell, Field, inputCls, btnPrimary } from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, "0"));
const months = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const years = Array.from({ length: 70 }, (_, i) => String(new Date().getFullYear() - 5 - i));

export default function Register() {
  const nav = useNavigate();
  const [f, setF] = useState({ nome: "", cognome: "", giorno: "", mese: "", anno: "", istituto: "", classe: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.giorno || !f.mese || !f.anno) return toast.error("Inserisci la data di nascita completa");
    setLoading(true);
    try {
      const { giorno, mese, anno, ...rest } = f;
      await api.post("/auth/register", { ...rest, data_nascita: `${anno}-${mese}-${giorno}` });
      toast.success("Registrazione completata. Ora accedi.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const sel = `${inputCls} appearance-none`;
  return (
    <AuthShell eyebrow="02 — Nuovo Studente" title="Crea il tuo profilo di studio.">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Nome"><input data-testid="register-student-nome-input" className={inputCls} value={f.nome} onChange={set("nome")} required /></Field>
          <Field label="Cognome"><input data-testid="register-student-cognome-input" className={inputCls} value={f.cognome} onChange={set("cognome")} required /></Field>
        </div>
        <Field label="Data di nascita">
          <div className="grid grid-cols-3 gap-3" data-testid="register-student-dob-input">
            <select data-testid="register-dob-day" className={sel} value={f.giorno} onChange={set("giorno")} required>
              <option value="">Giorno</option>{days.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
            <select data-testid="register-dob-month" className={sel} value={f.mese} onChange={set("mese")} required>
              <option value="">Mese</option>{months.map((m, i) => <option key={m} value={String(i + 1).padStart(2, "0")}>{m}</option>)}
            </select>
            <select data-testid="register-dob-year" className={sel} value={f.anno} onChange={set("anno")} required>
              <option value="">Anno</option>{years.map((y) => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
        </Field>
        <div className="grid sm:grid-cols-3 gap-5">
          <div className="sm:col-span-2"><Field label="Istituto scolastico"><input data-testid="register-student-istituto-input" className={inputCls} value={f.istituto} onChange={set("istituto")} required placeholder="Liceo Scientifico G. Galilei" /></Field></div>
          <Field label="Classe e sezione"><input data-testid="register-student-classe-input" className={inputCls} value={f.classe} onChange={set("classe")} required placeholder="3A" maxLength={6} /></Field>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Email"><input data-testid="register-student-email-input" type="email" className={inputCls} value={f.email} onChange={set("email")} required /></Field>
          <Field label="Password (min. 6)"><input data-testid="register-student-password-input" type="password" minLength={6} className={inputCls} value={f.password} onChange={set("password")} required /></Field>
        </div>
        <div className="flex flex-wrap items-center gap-6 pt-3">
          <button data-testid="register-student-submit-btn" disabled={loading} className={btnPrimary}>
            {loading ? "Registrazione…" : "Registrati"} <ArrowRight className="w-4 h-4" />
          </button>
          <Link to="/login" data-testid="go-login-link" className="text-sm font-medium underline underline-offset-4 hover:text-[#0D9488]">Hai già un account? Accedi</Link>
        </div>
      </form>
    </AuthShell>
  );
}
